// extracted by mini-css-extract-plugin
export var blue = "Button-module--blue--6c33b";
export var core = "Button-module--core--377a5";
export var green = "Button-module--green--acd3d";
export var white = "Button-module--white--11737";